module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/devices/display-3-bbd2d6bc6aaaf667532b533793a9eff5.svg";